/**
 * 自选列表行情排序（最新价 / 涨跌幅）相关枚举与配置。
 *
 * 需求约束：
 * - 排序仅作用于展示层，不写回基础顺序（sort_order），仅当前页面会话内有效；
 * - 最新价与涨跌幅互斥，仅允许一个字段处于激活状态。
 *
 * @module pages/find/stock/constants/watchlistQuoteSort
 */

/** 行情排序字段 */
export const QUOTE_SORT_FIELD = Object.freeze({
  LAST_PRICE: 'lastPrice',
  CHANGE_PCT: 'changePct'
});

/** 行情排序方向 */
export const QUOTE_SORT_DIRECTION = Object.freeze({
  ASC: 'asc',
  DESC: 'desc'
});

/** 行情变动后的重排节流间隔：需求要求合并变化后最少每 2 秒重排一次 */
export const QUOTE_RESORT_INTERVAL_MS = 2000;
